import { faCreditCard } from '@fortawesome/pro-regular-svg-icons'
import { Card, Title, Text, Flex } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreUserPrimaryPaymentSource } from '@flecto/types'
import { Icon } from '@flecto/ui'

type PaymentMethodProps = {
  primary_payment_source: CoreUserPrimaryPaymentSource | null
}

export function PaymentMethod({ primary_payment_source }: PaymentMethodProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_billing' })

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }

  return (
    <Card withBorder bg='gray.0' w='100%'>
      <Title order={5} mb='sm'>
        {t('title_payment_method')}
      </Title>
      <Flex align='center' gap='sm'>
        <Icon icon={faCreditCard} color='gray.7' />
        {primary_payment_source ? (
          <Text color='gray.7'>
            {`${capitalizeFirstLetter(primary_payment_source?.brand || '')} ${primary_payment_source?.type === 'card' && t('payment_card')} ${t('payment_ending')} ${primary_payment_source?.last4}`}
          </Text>
        ) : (
          <Text color='gray.7'>{t('no_payment_method')}</Text>
        )}
      </Flex>
    </Card>
  )
}
